export class SelectHtmlModel {
  constructor(public options: any[] = [], public disabled: boolean = false) {}
}
